<template>
  <div class="row mt-3">
    <div class="col-md-12">
      <h5 class="font-weight-bold">Pessoa(s) com Deficiência</h5>
      <div v-for="(usuario, index) in item.familiares" :key="index">
        <div class="p-0 col-12 mb-3" v-if="usuario.saude && usuario.saude.length > 0">
          <table class="table table-bordered">
            <tbody>
              <tr class="col-12">
                <td colspan="2">
                  <router-link :to="'/dashboard/usuario/edit/' + usuario.id">
                    <strong>
                      {{ usuario.nome_completo }}
                    </strong>
                  </router-link>
                  <br />
                  Idade: {{ usuario.idade }} ano(s)<br />
                </td>
              </tr>
              <tr>
                <th>Tem deficiência?</th>
                <td>
                  <span v-if="usuario.saude[0].deficiencia != null">
                    {{ usuario.saude[0].deficiencia == 1 ? "Sim" : "Não" }}
                  </span>
                  <span v-else>
                    <b-link
                      :to="'/dashboard/usuario/edit/' + usuario.id"
                      title="Informação ausente"
                      v-b-tooltip.hover
                    >
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="warning"
                        animation="fade"
                      ></b-icon>
                    </b-link>
                  </span>
                </td>
              </tr>
              <tr v-if="usuario.saude[0].deficiencia == 1">
                <th>Tipo de deficiência :</th>
                <td>
                  <span v-if="usuario.saude[0].def_cegueira">Cegueira,</span>
                  <span v-else-if="usuario.saude[0].def_baixa_visao">Baixa Visão,</span>
                  <span v-if="usuario.saude[0].def_surdez_servera"
                    >Surdez severa/profunda,</span
                  >
                  <span v-if="usuario.saude[0].def_surdez_leve"
                    >Surdez leve/moderada,</span
                  >
                  <span v-if="usuario.saude[0].def_fisica">Deficiência física,</span>
                  <span v-if="usuario.saude[0].def_mental_intelectual"
                    >Deficiência mental ou intelectual,</span
                  >
                  <span v-if="usuario.saude[0].def_sindrome_down">Síndrome de Down,</span>
                  <span v-if="usuario.saude[0].def_transtorno_doenca_mental"
                    >Transtorno/doença mental</span
                  >
                </td>
              </tr>
              <tr v-if="usuario.saude[0].deficiencia == 1">
                <th>Necessita de cuidados constantes de outra pessoa:</th>
                <td>
                  <span
                    v-if="
                      usuario.saude[0].ajuda_familia != null ||
                      usuario.saude[0].ajuda_especializada != null ||
                      usuario.saude[0].ajuda_instituicao != null ||
                      usuario.saude[0].ajuda_vizinhos != null ||
                      usuario.saude[0].ajuda_outra_forma != null
                    "
                  >
                    {{
                      usuario.saude[0].ajuda_familia == 1 ||
                      usuario.saude[0].ajuda_especializada == 1 ||
                      usuario.saude[0].ajuda_instituicao == 1 ||
                      usuario.saude[0].ajuda_vizinhos == 1 ||
                      usuario.saude[0].ajuda_outra_forma == 1
                        ? "Sim"
                        : "Não"
                    }}
                  </span>
                  <span v-else>
                    <b-link
                      :to="'/dashboard/usuario/edit/' + usuario.id"
                      title="Informação ausente"
                      v-b-tooltip.hover
                    >
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="warning"
                        animation="fade"
                      ></b-icon>
                    </b-link>
                  </span>
                </td>
              </tr>
              <tr v-if="usuario.saude[0].deficiencia == 1">
                <th>Responsável pelo cuidado</th>
                <td>
                  <span v-if="usuario.saude[0].responsavel_nome">
                    {{ usuario.saude[0].responsavel_nome }}
                  </span>
                  <span v-else>
                    <b-link
                      :to="'/dashboard/usuario/edit/' + usuario.id"
                      title="Informação ausente"
                      v-b-tooltip.hover
                    >
                      <b-icon
                        icon="exclamation-triangle-fill"
                        variant="warning"
                        animation="fade"
                      ></b-icon>
                    </b-link>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <h4 class="text-secondary" v-if="index == item.familiares.length - 1">
            <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
            Informações ausentes no prontuário do Usuário.
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["item"],
};
</script>
